
// All rights reserved.  No part of this work may be reproduced, stored in a
// retrieval system, adopted or transmitted in any form or by any means,
// electronic, mechanical, photographic, graphic, optic recording or otherwise,
// translated in any language or computer language, without the prior written
// permission of  Uniphore system software limited.

// Uniphore system software limited.
// Vaishnavi Silicon Terrace, B- Block, 
// 3rd & 4th floor, Hosur Rd, 
// Adugodi, Bengaluru, Karnataka 560095

// India

// Copyright 2019 Uniphore system software limited.

// Modification History

// Date            Version          Author                            Description
// ----------     -----------      ---------------                   ----------------------------------------
// 20-11-2019   1                  Pappuraj                          Development
// 30-11-2019   1.1                Pappuraj                           Bug fixed 


import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Facebook, FacebookLoginResponse } from '@ionic-native/facebook/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
// import { TwitterConnect } from '@ionic-native/twitter-connect/ngx';
@Component({
  selector: 'prospect-user',
  templateUrl: './prospectuser.component.html',
  styleUrls: ['./prospectuser.component.scss'],
})
export class ProspectUserComponent implements OnInit {
  newuserForm: FormGroup;
  langcontext: any;
  context: any;
  headingTitle: any;
  formsubmitted: boolean = false;
  selectcheckbox: boolean = false;
  errormessage;
  pincheck: boolean = false;
  agreecheck: any = false;
  mobile;
  pincode;
  name;
  disclimerFlg: any = "false";

  constructor(public platform: Platform, public _sanitizer: DomSanitizer, public navCtrl: NavController, public cd: ChangeDetectorRef, public formBuilder: FormBuilder, public cmndef: CommonDefinitionService, public cmndecl: CommonDeclarationService, public api: RestapiService, public fb: Facebook, public inappbrowser: InAppBrowser, public router: Router) {
    console.log(this.cmndecl.LanguageJson);
  }

  ngOnInit() {
    localStorage.removeItem("tackbackenable");
    if (this.cmndecl.LanguageJson) {
      this.langcontext = this.cmndecl.LanguageJson.pages[0]['Newuser'];
      console.log(this.langcontext)
    }
    else {
      this.cmndecl.LanguageJson = JSON.parse(localStorage.languageJson);
      this.langcontext = this.cmndecl.LanguageJson['pages'][0].Newuser;
    }
    this.platform.ready().then(() => {
      this.api.postapi("getContextMenu", {}).then(data => {
        console.log(data);
        this.cmndecl.storeProcess(data,"contexualmenu");
      }, err => {
        console.log("err");
      });
    });

    this.headingTitle = this.langcontext.heading.text;

    this.newuserForm = this.formBuilder.group({
      name: new FormControl('', Validators.required),
      mobile: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(15),

      ])),
      // mobile: new FormControl('', Validators.required),
      pincode: new FormControl('', Validators.required),
      // checkboxtype : new FormControl('',Validators.required)
    });
  }

  pincodevalidcheck(ev) {
    console.log(ev);
    let data = {};
    this.pincheck = false;
    data['pinCode'] = ev.detail.value;
    if (ev.detail.value.length >= 6) {
      this.pincheck = true;
      this.api.postapi("verifyPincode", data).then(response => {
        if (response['responseCode'] == "001" && response['message'] == "Please enter a valid pincode") {
          this.errormessage = this.langcontext.Pincode.checkpin;
        }
        if (response['responseCode'] == "001" && response['message'] == "Valid Pin Code") {
          this.errormessage = "";
        }
      })
    }
  }

  twLogin() {
    // this.twitter.login().then(onSuccess => {
    //   console.log(onSuccess)
    // }, onError => {
    //   console.log(onError)
    // });
  }

  onSuccess(response) {
    console.log(response);

    // Will console log something like:
    // {
    //   userName: 'myuser',
    //   userId: '12358102',
    //   secret: 'tokenSecret'
    //   token: 'accessTokenHere'
    // }
  }

  gotoVerifyOtp() {
    console.log(this.newuserForm)
    if (this.newuserForm.valid && this.agreecheck && this.errormessage == "") {
      this.cmndef.userType = 'new'
      let data = {
        "requestType": "REGISTER",
        "mobileNo": this.newuserForm.value.mobile,
        "pincode": this.newuserForm.value.pincode,
        "customerName": this.newuserForm.value.name,
        "userType": "3"
      }
      this.api.postapi("userRegistration", data).then(async response => {
        if (response) {
          data['state'] = response['state'];
          this.cmndef.previousPage = ""
          await this.cmndecl.storeProcess(data,"profile")
          sessionStorage.CurrentPage = "/verifyotppros";
          this.navCtrl.navigateForward('/verifyotppros')
        }
      })
    }
  }

  termscont() {
    if (this.agreecheck == false)
      this.agreecheck = true
    else
      this.agreecheck = false
  }

  validatefun(flg: any) {
    if (flg == 'name') {
      this.name = this.name.replace(/[^a-zA-Z ]+/g, '');
      this.name = this.name.replace("  ", ' ');
      console.log(this.name.length);
      if(this.name.length == 1)
        this.name = this.name.replace(" ", '');
    }
    else if (flg == 'mobile') {
      this.mobile = this.mobile.replace(/[^0-9]/g, '');
    }
    else if (flg == 'pincode') {
      this.pincode = this.pincode.replace(/[^0-9]/g, '');
    }
    // this.cd.detectChanges();
  }
  async disclaimer() {
    this.cmndecl.Actionsheetenable = true;
    this.disclimerFlg = "true";
  }


  fbLogin() {
    let req: any;
    let res: any;
    this.fb.getLoginStatus().then(data => {
      console.log(data);
      this.fb.login(['public_profile', 'user_friends', 'email'])
        .then((res: FacebookLoginResponse) => console.log('Logged into Facebook!', res))
        .catch(e => console.log('Error logging into Facebook', e));
    }, err => {
      console.log(err);
    })

    // this.fb.logEvent(this.fb.EVENTS.EVENT_NAME_ADDED_TO_CART);

  }

}
